import React, { createContext, useContext, useState, useEffect } from 'react'
import toast from 'react-hot-toast'

const CartContext = createContext()

export const useCart = () => {
  const context = useContext(CartContext)
  if (!context) {
    throw new Error('useCart must be used within a CartProvider')
  }
  return context
}

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([])

  // Charger le panier depuis localStorage au démarrage
  useEffect(() => {
    const savedCart = localStorage.getItem('contactCart')
    if (savedCart) {
      try {
        setCartItems(JSON.parse(savedCart))
      } catch (error) {
        console.error('Erreur lors du chargement du panier:', error)
      }
    }
  }, [])

  // Sauvegarder le panier dans localStorage à chaque modification
  useEffect(() => {
    localStorage.setItem('contactCart', JSON.stringify(cartItems))
  }, [cartItems])

  // Ajouter un produit au panier
  const addToCart = (product) => {
    // Vérifier si le produit est déjà dans le panier
    const existingItem = cartItems.find(item => item.id === product.id)

    if (!existingItem) {
      setCartItems(prev => [...prev, {
        id: product.id,
        name: product.name,
        code: product.code,
        category: product.category,
        capacity: product.capacity,
        image_url: product.image_url,
        slug: product.slug
      }])
      toast.success(`${product.name} ajouté au panier`, {
        icon: '🛒',
      })
      return true
    } else {
      toast.error('Ce produit est déjà dans le panier', {
        icon: 'ℹ️',
      })
    }
    return false
  }

  // Retirer un produit du panier
  const removeFromCart = (productId) => {
    const product = cartItems.find(item => item.id === productId)
    setCartItems(prev => prev.filter(item => item.id !== productId))
    if (product) {
      toast.success('Produit retiré du panier', {
        icon: '🗑️',
      })
    }
  }

  // Vider le panier
  const clearCart = () => {
    setCartItems([])
  }

  // Vérifier si un produit est dans le panier
  const isInCart = (productId) => {
    return cartItems.some(item => item.id === productId)
  }

  const value = {
    cartItems,
    addToCart,
    removeFromCart,
    clearCart,
    isInCart,
    cartCount: cartItems.length
  }

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  )
}
